/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  /* Apex – navigering för produktgalleriet */
;(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '[data-gallery-direction], [data-thumbnail-scroll]'
    );

    if (!button) {
      return;
    }

    var gallery = button.closest('.product-gallery');

    if (!gallery) {
      return;
    }

    var thumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll(
        '.product-gallery__thumbnail:not(.is-filtered)'
      )
    );

    if (thumbnails.length < 2) {
      return;
    }

    var currentIndex = thumbnails.findIndex(function (thumbnail) {
      return thumbnail.classList.contains('is-nav-selected');
    });

    if (currentIndex < 0) {
      currentIndex = 0;
    }

    var direction =
      button.getAttribute('data-gallery-direction') ||
      button.getAttribute('data-thumbnail-scroll');

    var nextIndex;

    if (direction === 'next') {
      nextIndex = (currentIndex + 1) % thumbnails.length;
    } else {
      nextIndex =
        (currentIndex - 1 + thumbnails.length) %
        thumbnails.length;
    }

    var nextThumbnail = thumbnails[nextIndex];

    event.preventDefault();
    nextThumbnail.click();

    requestAnimationFrame(function () {
      var isDesktop = window.matchMedia(
        '(min-width: 1000px)'
      ).matches;

      if (isDesktop) {
        var thumbnailList = gallery.querySelector(
          '.product-gallery__thumbnail-list'
        );

        if (thumbnailList) {
          thumbnailList.scrollTop = Math.max(
            0,
            nextThumbnail.offsetTop -
              (thumbnailList.clientHeight -
                nextThumbnail.offsetHeight) /
                2
          );
        }
      } else {
        var mobileScroller = gallery.querySelector(
          '.product-gallery__thumbnail-scroller .scroller__inner'
        );

        if (mobileScroller) {
          mobileScroller.scrollLeft = Math.max(
            0,
            nextThumbnail.offsetLeft -
              (mobileScroller.clientWidth -
                nextThumbnail.offsetWidth) /
                2
          );
        }
      }
    });
  });
}());

/* Apex – stabil expandering av den långa collectionbeskrivningen. */
;(function () {
  function collapsedHeight(element) {
    var value = window.getComputedStyle(element).getPropertyValue(
      '--apex-collection-description-collapsed-height'
    );

    return parseFloat(value) || 190;
  }

  function prepareCollectionDescription(root) {
    root.querySelectorAll('[data-apex-collection-description-expandable]').forEach(function (expandable) {
      if (expandable.dataset.apexExpandableReady === 'true') {
        return;
      }

      var container = expandable.closest('.apex-collection-bottom-description__inner');
      var toggle = container && container.querySelector('[data-apex-collection-description-toggle]');
      var toggleText = toggle && toggle.querySelector('[data-apex-collection-description-toggle-text]');
      var closedHeight = collapsedHeight(expandable);

      if (!toggle || !toggleText) {
        return;
      }

      expandable.dataset.apexExpandableReady = 'true';

      if (expandable.scrollHeight <= closedHeight + 4) {
        expandable.classList.add('is-open');
        expandable.style.maxHeight = 'none';
        toggle.hidden = true;
        return;
      }

      expandable.classList.add('is-ready');
      expandable.style.maxHeight = closedHeight + 'px';
      toggle.hidden = false;

      toggle.addEventListener('click', function () {
        var isOpen = expandable.classList.contains('is-open');

        if (isOpen) {
          expandable.style.maxHeight = expandable.scrollHeight + 'px';
          expandable.offsetHeight;
          expandable.classList.remove('is-open');
          expandable.style.maxHeight = collapsedHeight(expandable) + 'px';
          toggle.setAttribute('aria-expanded', 'false');
          toggleText.textContent = 'Visa hela beskrivningen';
        } else {
          expandable.classList.add('is-open');
          expandable.style.maxHeight = expandable.scrollHeight + 'px';
          toggle.setAttribute('aria-expanded', 'true');
          toggleText.textContent = 'Visa mindre';
        }
      });

      expandable.addEventListener('transitionend', function (event) {
        if (event.propertyName === 'max-height' && expandable.classList.contains('is-open')) {
          expandable.style.maxHeight = 'none';
        }
      });
    });
  }

  prepareCollectionDescription(document);

  document.addEventListener('shopify:section:load', function (event) {
    prepareCollectionDescription(event.target);
  });
}());

/* Apex – färgval på alla fristående produktkaruseller byter kortets bild. */
;(function () {
  document.addEventListener('change', function (event) {
    var swatch = event.target.closest(
      '[data-section-type="apex-featured-collection"] .product-item__swatch-list .color-swatch__radio'
    );

    if (!swatch) {
      return;
    }

    var productItem = swatch.closest('.product-item');

    if (!productItem) {
      return;
    }

    var variantUrl = swatch.getAttribute('data-variant-url');
    var imageUrl = swatch.getAttribute('data-image-url');
    var mediaId = swatch.getAttribute('data-media-id');
    var imageLink = productItem.querySelector('.product-item__image-wrapper');
    var titleLink = productItem.querySelector('.product-item__title');
    var originalImage = productItem.querySelector('.product-item__primary-image');

    if (variantUrl) {
      if (imageLink) {
        imageLink.setAttribute('href', variantUrl);
      }

      if (titleLink) {
        titleLink.setAttribute('href', variantUrl);
      }
    }

    if (!imageUrl || !originalImage || mediaId === originalImage.getAttribute('data-media-id')) {
      return;
    }

    var replacementImage = originalImage.cloneNode(false);
    var aspectRatio = parseFloat(swatch.getAttribute('data-image-aspect-ratio'));

    replacementImage.removeAttribute('srcset');
    replacementImage.setAttribute('src', imageUrl);
    replacementImage.setAttribute('data-media-id', mediaId || '');

    if (aspectRatio > 0 && originalImage.parentNode) {
      originalImage.parentNode.style.paddingBottom = (100 / aspectRatio) + '%';
    }

    originalImage.parentNode.replaceChild(replacementImage, originalImage);
  });
}());

/* Apex – kort collectionbeskrivning ska alltid kunna öppnas med Visa mer. */
;(function () {
  function prepareCollectionDescriptions(root) {
    root.querySelectorAll('.apex-collection-short-description.expandable-content').forEach(function (description) {
      description.classList.add('expandable-content--expandable');
      description.setAttribute('aria-expanded', 'false');

      var toggleText = description.querySelector('.expandable-content__toggle-text');

      if (toggleText && toggleText.getAttribute('data-view-more')) {
        toggleText.textContent = toggleText.getAttribute('data-view-more');
      }
    });
  }

  prepareCollectionDescriptions(document);

  document.addEventListener('shopify:section:load', function (event) {
    prepareCollectionDescriptions(event.target);
  });
}());

/* Apex – stäng drawer-menyn med Escape. */
;(function () {
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    var menu = document.querySelector('.apex-drawer-nav #mobile-menu[aria-hidden="false"]');
    var toggle = document.querySelector('.apex-drawer-nav [aria-controls="mobile-menu"]');

    if (menu && toggle) {
      toggle.click();
      toggle.focus();
    }
  });
}());

/* Apex – fristående karusell för Apex utvald kollektion */
;(function () {
  function visibleItems() {
    if (window.matchMedia('(max-width: 640px)').matches) {
      return 1;
    }

    if (window.matchMedia('(max-width: 999px)').matches) {
      return 3;
    }

    return 4;
  }

  function render(carousel) {
    var track = carousel.querySelector('[data-apex-featured-carousel-track]');
    var viewport = carousel.querySelector('.scroller__inner');
    var items = track ? track.querySelectorAll('.product-item') : [];
    var previous = carousel.querySelector('[data-apex-featured-carousel="previous"]');
    var next = carousel.querySelector('[data-apex-featured-carousel="next"]');

    if (!track || !viewport || !previous || !next || items.length === 0) {
      return;
    }

    var shown = visibleItems();
    var maxIndex = Math.max(0, items.length - shown);
    var requestedIndex = parseInt(carousel.getAttribute('data-apex-featured-index') || '0', 10);

    if (!Number.isFinite(requestedIndex)) {
      requestedIndex = 0;
    }

    var index = Math.max(0, Math.min(requestedIndex, maxIndex));
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
    var step = items[0].getBoundingClientRect().width + gap;
    var lastItem = items[items.length - 1];
    var contentWidth = lastItem.offsetLeft + lastItem.offsetWidth;
    var maxOffset = Math.max(0, contentWidth - viewport.clientWidth);
    var offset = Math.min(index * step, maxOffset);

    carousel.setAttribute('data-apex-featured-index', index);
    track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
    previous.disabled = offset <= 1;
    next.disabled = offset >= maxOffset - 1;
  }

  function initialise(scope) {
    var carousels = [];

    if (scope.matches && scope.matches('[data-section-type="apex-featured-collection"] .apex-featured-collection__scroller')) {
      carousels.push(scope);
    }

    scope.querySelectorAll('[data-section-type="apex-featured-collection"] .apex-featured-collection__scroller').forEach(function (carousel) {
      carousels.push(carousel);
    });

    carousels.forEach(function (carousel) {
      if (!carousel.hasAttribute('data-apex-featured-ready')) {
        carousel.setAttribute('data-apex-featured-ready', 'true');
        carousel.setAttribute('data-apex-featured-index', '0');

        var touchStart = 0;
        carousel.addEventListener('touchstart', function (event) {
          touchStart = event.changedTouches[0].clientX;
        }, { passive: true });

        carousel.addEventListener('touchend', function (event) {
          var distance = event.changedTouches[0].clientX - touchStart;

          if (Math.abs(distance) < 35) {
            return;
          }

          var direction = distance < 0 ? 1 : -1;
          var current = parseInt(carousel.getAttribute('data-apex-featured-index') || '0', 10);
          carousel.setAttribute('data-apex-featured-index', current + direction);
          render(carousel);
        }, { passive: true });
      }

      render(carousel);
      window.requestAnimationFrame(function () { render(carousel); });
      window.setTimeout(function () { render(carousel); }, 300);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-apex-featured-carousel]');

    if (!button) {
      return;
    }

    if (button.disabled) {
      event.preventDefault();
      return;
    }

    var carousel = button.closest('.apex-featured-collection__scroller');
    var current = parseInt(carousel.getAttribute('data-apex-featured-index') || '0', 10);
    var direction = button.getAttribute('data-apex-featured-carousel') === 'next' ? 1 : -1;

    event.preventDefault();
    carousel.setAttribute('data-apex-featured-index', current + direction);
    render(carousel);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initialise(document);
  });

  window.addEventListener('load', function () {
    initialise(document);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-section-type="apex-featured-collection"] .apex-featured-collection__scroller').forEach(function (carousel) {
      render(carousel);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
}());
/* Apex – korrigera en kombination som inte motsvarar någon faktisk variant */
;(function () {
  function getPicker(formId) {
    return Array.prototype.find.call(
      document.querySelectorAll('variant-picker'),
      function (picker) {
        return picker.getAttribute('form-id') === formId;
      }
    );
  }

  function isDisabledOption(input) {
    return Boolean(input.closest(
      '.block-swatch--disabled, .color-swatch--disabled, .variant-swatch--disabled'
    ));
  }

  document.addEventListener('variant:changed', function (event) {
    var detail = event.detail || {};
    var form = detail.formId ? document.getElementById(detail.formId) : null;

    if (!form) {
      return;
    }

    if (detail.variant && detail.variant.id) {
      form.classList.remove('apex-invalid-combination');
      return;
    }

    form.classList.add('apex-invalid-combination');

    window.requestAnimationFrame(function () {
      var picker = getPicker(detail.formId);

      if (!picker) {
        return;
      }

      var invalidSelection = picker.querySelector(
        '.block-swatch--disabled input:checked, ' +
        '.color-swatch--disabled input:checked, ' +
        '.variant-swatch--disabled input:checked'
      );

      if (!invalidSelection) {
        return;
      }

      var replacement = Array.prototype.find.call(
        picker.querySelectorAll('input[name="' + invalidSelection.name + '"]'),
        function (input) {
          return input !== invalidSelection && !isDisabledOption(input);
        }
      );

      if (replacement) {
        replacement.click();
      }
    });
  });
}());

/* Apex – placera appens offertknapp direkt efter antal för en nollprisvariant. */
;(function () {
  function buttonText(element) {
    return (element.value || element.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function moveQuoteButton(form) {
    if (!form || !form.classList.contains('apex-zero-price-variant')) {
      return;
    }

    var target = form.querySelector('[data-apex-quote-button-target]');

    if (!target) {
      return;
    }

    var quoteButton = Array.prototype.find.call(
      form.querySelectorAll('button, a, input[type="button"], input[type="submit"]'),
      function (element) {
        return buttonText(element).indexOf('begär offert') !== -1;
      }
    );

    if (quoteButton && !target.contains(quoteButton)) {
      target.appendChild(quoteButton);
    }
  }

  function releaseQuoteButton(form) {
    var target = form && form.querySelector('[data-apex-quote-button-target]');
    var quoteButton = target && target.querySelector(
      'button, a, input[type="button"], input[type="submit"]'
    );

    if (quoteButton) {
      form.appendChild(quoteButton);
    }
  }

  function initialise(root) {
    root.querySelectorAll('.product-form.apex-zero-price-variant').forEach(moveQuoteButton);
  }

  document.addEventListener('variant:changed', function (event) {
    var detail = event.detail || {};
    var form = detail.formId ? document.getElementById(detail.formId) : null;
    var variant = detail.variant;

    if (!form || form.classList.contains('apex-offert-product')) {
      return;
    }

    /* Variantblocket byts direkt efter eventet. Flytta först ut appknappen
       så att den inte raderas tillsammans med det gamla blocket. */
    releaseQuoteButton(form);

    form.classList.toggle(
      'apex-zero-price-variant',
      Boolean(variant && variant.id && Number(variant.price) <= 0)
    );

    window.setTimeout(function () {
      moveQuoteButton(form);
    }, 0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initialise(document);

    new MutationObserver(function () {
      initialise(document);
    }).observe(document.body, { childList: true, subtree: true });
  });
}());

/* Apex – uppdatera leveransstatus när variant byts */
;(function () {
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var formId = event.detail && event.detail.formId;

    if (!variant) {
      return;
    }

    window.requestAnimationFrame(function () {
      var form = formId ? document.getElementById(formId) : null;
      var scope = form ? form.closest('product-rerender') : null;

      if (!scope) {
        scope = document;
      }

      var statusBlock = scope.querySelector('.product-delivery-status');
      var inventoryData = scope.querySelector('[data-apex-variant-stock]');

      if (!statusBlock || !inventoryData) {
        return;
      }

      var inventory;

      try {
        inventory = JSON.parse(inventoryData.textContent);
      } catch (error) {
        return;
      }

      var selectedInventory = inventory[String(variant.id)];

      if (!selectedInventory || !selectedInventory.tracked) {
        return;
      }

      var statusElement = statusBlock.querySelector(
        '.product-delivery-status__status'
      );

      var timeElement = statusBlock.querySelector(
        '.product-delivery-status__time'
      );

      if (!statusElement) {
        return;
      }

      if (!timeElement) {
        timeElement = document.createElement('span');
        timeElement.className = 'product-delivery-status__time';
        statusElement.insertAdjacentElement('afterend', timeElement);
      }

      if (selectedInventory.quantity > 0) {
        statusElement.textContent = '✓ Finns i lager';
        timeElement.textContent = ' – Omgående leverans';
      } else {
        statusElement.textContent = '✓ Beställningsvara';
        timeElement.textContent = ' – Leveranstid på förfrågan';
      }
    });
  });
}());

/* Apex – exakt navigering från produktsammanfattningen */
;(function () {
  function getStickyHeaderOffset() {
    var header = document.querySelector('[data-section-type="header"]');

    if (!header) {
      return 20;
    }

    var stickyContainer = header.closest('.shopify-section') || header;
    var style = window.getComputedStyle(stickyContainer);
    var rect = stickyContainer.getBoundingClientRect();
    var isSticky = style.position === 'sticky' || style.position === 'fixed';

    if (isSticky && rect.top <= 1 && rect.bottom > 0) {
      return rect.bottom + 20;
    }

    return 20;
  }

  function scrollToProductSection(target, hash) {
    var top = target.getBoundingClientRect().top + window.pageYOffset;
    top -= getStickyHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', hash);
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-apex-product-jump]');

    if (!link) {
      return;
    }

    var hash = link.getAttribute('href');

    if (!hash || hash.charAt(0) !== '#') {
      return;
    }

    var target = document.querySelector(hash);

    if (!target) {
      return;
    }

    event.preventDefault();

    var collapsibleButton = target.querySelector(
      '[data-action="toggle-collapsible"][aria-expanded="false"]'
    );

    if (collapsibleButton) {
      collapsibleButton.click();

      window.setTimeout(function () {
        scrollToProductSection(target, hash);
      }, 350);
    } else {
      scrollToProductSection(target, hash);
    }
  });
}());

/* Apex – bygg en specifikationstabell från RTF-rader skrivna som "Rubrik: värde" */
;(function () {
  function cleanLeadingSeparator(element) {
    var node = element.firstChild;

    while (node && node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
      var emptyNode = node;
      node = node.nextSibling;
      emptyNode.remove();
    }

    if (node && node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace(/^\s*:\s*/, '');
    }
  }

  function createGroup(title) {
    var group = document.createElement('div');
    var table = document.createElement('table');
    var body = document.createElement('tbody');

    group.className = 'apex-specification-table__group';
    table.className = 'apex-specification-table__table';

    if (title) {
      var head = document.createElement('thead');
      var headRow = document.createElement('tr');
      var heading = document.createElement('th');

      heading.colSpan = 2;
      heading.scope = 'colgroup';
      heading.textContent = title;
      headRow.appendChild(heading);
      head.appendChild(headRow);
      table.appendChild(head);
    }

    table.appendChild(body);
    group.appendChild(table);

    return {
      element: group,
      body: body
    };
  }

  function transformSpecificationTable(element) {
    if (element.hasAttribute('data-apex-specification-table-ready')) {
      return;
    }

    var richText = element.querySelector('.metafield-rich_text_field');

    if (!richText) {
      return;
    }

    var sourceElements = Array.prototype.slice.call(richText.children);
    var output = document.createElement('div');
    var currentGroup = null;
    var parsedRows = 0;

    output.className = 'apex-specification-table';

    sourceElements.forEach(function (sourceElement) {
      if (/^H[1-6]$/.test(sourceElement.tagName)) {
        currentGroup = createGroup(sourceElement.textContent.trim());
        output.appendChild(currentGroup.element);
        return;
      }

      var labelElement = sourceElement.querySelector('strong');
      var sourceText = sourceElement.textContent.trim();
      var separatorIndex = sourceText.indexOf(':');
      var hasTextSeparator = separatorIndex > 0;

      if (sourceElement.tagName === 'P' && (labelElement || hasTextSeparator)) {
        if (!currentGroup) {
          currentGroup = createGroup(
            element.getAttribute('data-default-group-title') || ''
          );
          output.appendChild(currentGroup.element);
        }

        var row = document.createElement('tr');
        var label = document.createElement('th');
        var value = document.createElement('td');
        label.scope = 'row';

        if (labelElement) {
          var valueContent = sourceElement.cloneNode(true);
          var valueLabel = valueContent.querySelector('strong');

          label.textContent = labelElement.textContent.trim().replace(/:\s*$/, '');

          if (valueLabel) {
            valueLabel.remove();
          }

          cleanLeadingSeparator(valueContent);
          value.innerHTML = valueContent.innerHTML.trim() || '–';
        } else {
          label.textContent = sourceText.slice(0, separatorIndex).trim();
          value.textContent = sourceText.slice(separatorIndex + 1).trim() || '–';
        }

        row.appendChild(label);
        row.appendChild(value);
        currentGroup.body.appendChild(row);
        parsedRows += 1;
        return;
      }

      if (sourceElement.textContent.trim()) {
        var note = sourceElement.cloneNode(true);
        note.classList.add('apex-specification-table__note');
        output.appendChild(note);
      }
    });

    if (parsedRows === 0) {
      return;
    }

    richText.replaceWith(output);
    element.setAttribute('data-apex-specification-table-ready', 'true');
  }

  class ApexSpecificationTable extends HTMLElement {
    connectedCallback() {
      transformSpecificationTable(this);
    }
  }

  if (!window.customElements.get('apex-specification-table')) {
    window.customElements.define(
      'apex-specification-table',
      ApexSpecificationTable
    );
  }
}());
